import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import AttendanceTable from "@/components/AttendanceTable";

export default function TeacherAttendance() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/teacher/attendance");
        setData(res.data);
      } catch (e) {
        toast.error("Failed to load attendance");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="max-w-full" data-testid="teacher-attendance-page">
      <h1 className="font-heading text-2xl sm:text-3xl font-medium tracking-tight text-foreground">
        Attendance
      </h1>
      <p className="mt-1 text-muted-foreground">
        Your students across the semester's class days. Tap a name to open their profile.
      </p>

      <AttendanceTable
        data={data}
        loading={loading}
        linkBase="/teacher/students/"
        emptyText="No students assigned to you yet."
      />
    </div>
  );
}
